import { FC } from "react";
import { useSelector } from "react-redux";

import { IIconBandSetting } from "Bands/types";
import { copy } from "shared/assets";
import { Card } from "shared/components";
import { EditTable } from "../components";
import { IDataKeys } from "shared/types";
import { bandSettingsSelector } from "Bands/state";

const settingsCopy = copy.bandSettings.eventSettings.infoBlocks;

export const EditEventInfoBlocks: FC = () => {
  const initialItems = useSelector(
    bandSettingsSelector<IIconBandSetting>(IDataKeys.eventInfoBlockTypes)
  );

  return (
    <Card title={settingsCopy.edit}>
      <EditTable
        name="eventInfoBlock"
        initialItems={initialItems}
        hasDragAndDrop={true}
        hasIcon={true}
        addCopy={settingsCopy.add}
        dataKey={IDataKeys.eventInfoBlockTypes}
        modalTitle={settingsCopy.modalTitle}
        modalMessage={settingsCopy.modalMessage}
      />
    </Card>
  );
};
